import { Fraction } from 'bi-fraction';
import { BASE_SWAP_COST_V2, COST_PER_EXTRA_HOP_V2, COST_PER_INIT_TICK, ZKCRO_DECIMALS, } from '../constants';
export class GasFeeEstimator {
    constructor(options) {
        this.options = options;
    }
    async estimateGasForSwap(inputTokenAddress, outputTokenAddress) {
        let cost = BASE_SWAP_COST_V2;
        const { WZkCRO, vUSD } = this.options.addresses;
        // only support these routes (all both ways)
        // AGENTFUN - AGENTTOKEN  ->  no hops, only base cost
        // wzkCRO - AGENTFUN - AGENT TOKEN  ->  1 hop
        // vUSD - zkCRO - AGENTFUN - AGENTTOKEN  ->  2 hops
        if (inputTokenAddress === WZkCRO || outputTokenAddress === WZkCRO) {
            cost += COST_PER_EXTRA_HOP_V2;
        }
        else if (inputTokenAddress === vUSD || outputTokenAddress === vUSD) {
            cost += 2 * COST_PER_EXTRA_HOP_V2;
        }
        cost += COST_PER_INIT_TICK;
        const gasPrice = (await this.options.provider.getBlock('latest'))
            ?.baseFeePerGas;
        if (!gasPrice)
            throw new Error('Failed to get gas price');
        return new Fraction(gasPrice * BigInt(cost)).shr(ZKCRO_DECIMALS);
    }
}
